import React from 'react';
import PropTypes from 'prop-types';
import { linkType, responsiveImageType } from '../../propTypes';
import Card from '../Card';
import Caption, { captionPropTypes, captionDefaultProps } from './Caption';
import WishlistToggle from './WishlistToggle';

const Product = ({
  brand,
  className,
  image,
  link,
  price,
  ribbon,
  specialPrice,
  sku,
  title,
  colourTheme,
  brandTag,
}) => {
  const ready = !!sku;

  return (
    <Card
      className={className}
      format="portrait"
      image={image}
      clickthrough={link}
      ready={ready}
      title={title}
      colourTheme={colourTheme}
    >
      {ready && <WishlistToggle sku={sku} />}
      <Caption
        brand={brand}
        title={title}
        price={price}
        ribbon={ribbon}
        sku={sku}
        specialPrice={specialPrice}
        colourTheme={colourTheme}
        brandTag={brandTag}
      />
    </Card>
  );
};

export const productPropTypes = {
  ...captionPropTypes,
  image: responsiveImageType,
  link: linkType,
};

Product.propTypes = {
  className: PropTypes.string,
  ...productPropTypes,
};

export const productDefaultProps = {
  ...captionDefaultProps,
  image: undefined,
  link: undefined,
};

Product.defaultProps = {
  className: undefined,
  ...productDefaultProps,
};

export default Product;
